const constantsStorage = {
    // user
    USER: "userdata",
    USER_TOKEN: "userdata.lkey",
    USER_NEED_NAME_REGISTER: "userdata.need_name_register",

    // conditon setting
    CONDITION_SETTING: "condition_setting",
    CONDITION_SETTING_TASK: "condition_setting.task",
    CONDITION_SETTING_PERSON: "condition_setting.person",
    CONDITION_SETTING_MENU_TABLE_ID: "condition_setting.menu_table_id",

    // person condition 
    PERSON_CONDITION : "person_condition",
    //set-menu
    SET_MENU : "set_menu",
    SUBJECT_MENU : "subject_menu",
    TABLE_MENU : "table_menu",
    // chart
    CHART: "chart",
    //session
    SESSION: 'sessiondata',
    SESSION_DATA_LOGIN: 'session_data_login',
    OPTION_SET: "option_set",
    SAVE_MENU: "saveMenu",
    SAVE_SUBJECT_MENU: "saveSubjectMenu",
    CANVAS_OPTION_ORIGIN: "canvas_option_origin",

    // Synchronizes
    MENU_SYNC: "menu_sync"
}
export default constantsStorage;